import { Base } from "@app/controllers/base";

// Connects to data-controller="store--addons"
export default class extends Base {
  static targets = ["checkbox", "total", "grandTotal", "bookButton"];
  static values = { basePrice: Number };

  recalculate() {
    let addonTotal = 0;
    let selectedAddonIds = [];

    this.checkboxTargets.forEach((cb) => {
      if (cb.checked) {
        addonTotal += parseInt(cb.value, 10);
        selectedAddonIds.push(cb.dataset.addonId);
      }
    });

    const total = this.basePriceValue + addonTotal;
    if (this.hasTotalTarget) this.totalTarget.textContent = this.formatIDR(addonTotal);
    if (this.hasGrandTotalTarget) {
      this.grandTotalTarget.textContent = this.formatIDR(total);
    }

    if (this.hasBookButtonTarget) {
      const baseUrl = this.bookButtonTarget.dataset.baseUrl;
      const params = new URLSearchParams;

      selectedAddonIds.forEach(id => params.append("add_on_ids[]", id));

      this.bookButtonTarget.href = selectedAddonIds.length > 0 ? `${baseUrl}?${params.toString()}` : baseUrl;
    }
  }

  formatIDR(amount) {
    return `Rp${amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
  }
}
